import { render, staticRenderFns } from "./ArticoloAlternativo.vue?vue&type=template&id=2e84b073&scoped=true&"
import script from "./ArticoloAlternativo.vue?vue&type=script&lang=js&"
export * from "./ArticoloAlternativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84b073",
  null
  
)

export default component.exports